import React from 'react';

export default function HomePage() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  let navigateTo = '';
  console.log(ua);
  if (/android/i.test(ua)) {
    navigateTo = 'https://apps.apple.com/de/app/fit-mate24/id6584512797?l=en-GB';
  }
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    navigateTo = 'https://apps.apple.com/de/app/fit-mate24/id6584512797?l=en-GB';
  }
  if (/windows phone/i.test(ua)) {
    navigateTo = 'https://apps.apple.com/de/app/fit-mate24/id6584512797?l=en-GB';
  }
  navigateTo = 'https://apps.apple.com/de/app/fit-mate24/id6584512797?l=en-GB';

  return (
    <div
      style={{
        minHeight: '100vh',
        fontFamily: 'Californian FB'
      }}>
      <div style={{ overflow: 'hidden' }}>
        <div
          style={{
            position: 'relative',
            height: 550,
            width: '100%',
            background: `url(homepage.png) center center / cover no-repeat`,
          }}>
          <div
            style={{
              position: 'absolute',
              top: 40,
              left: 16,
              color: '#fff',
              fontWeight: 900,
              fontSize: 32,
              letterSpacing: -1,
            }}>
            <img src="fitmate.png" alt="" width={140} />
          </div>
          <a href={navigateTo}>
            <button
              style={{
                position: 'absolute',
                top: 30,
                right: 16,
                background: '#fff',
                border: 'none',
                borderRadius: 16,
                padding: '10px',
                fontSize: 14,
                cursor: 'pointer',
                color: '#000',
                fontFamily: 'Californian FB, serif',
                width: '30%',
                letterSpacing: 0.9,
              }}>
              Download
            </button>
          </a>
          <div
            style={{
              position: 'absolute',
              left: 20,
              right: 0,
              bottom: 40,
              color: '#fff',
              borderRadius: '0 0 14px 14px',
              boxShadow: '0 8px 12px #29292944',
              fontSize: 32,
              fontWeight: 600, // Poppins semibold
              fontFamily: 'Poppins, sans-serif',
              letterSpacing: 0.9,
            }}>
            Find your perfect fitness buddy!
          </div>
        </div>

        {/* CTA Section */}
        <div style={{ backgroundColor: '#faf4e4', padding: '30px 22px 22px 22px' }}>
          <div
            style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600, // Poppins semibold
              fontSize: 14,
              textAlign: 'center',
              color: '#C87E4C',
              marginBottom: 15,
              letterSpacing: 0.9,
            }}>
            Our Goal
          </div>
          <div
            style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600, // Poppins semibold
              fontSize: 16,
              color: '#000',
              letterSpacing: 0.9,
            }}>
            Fitness Social app
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginBottom: 20,
            }}>
            <img
              src="socialappicon.svg"
              alt="icon"
              style={{
                height: 80,
                width: 80,
                margin: 20,
              }}
            />
            <div style={{ display: 'flex', marginLeft: 100, fontWeight: 200, flexDirection: 'column' }}>
              <p style={{ fontSize: 15, fontFamily: 'Californian FB, serif', letterSpacing: 0.9 }}>
                Fit-Mate24 is a social fitness platform that helps people connect, train together, and build
                meaningful relationships through fitness and active lifestyles.
              </p>
              <p style={{ fontSize: 15, fontFamily: 'Californian FB, serif', letterSpacing: 0.9 }}>
                Whether you’re in the gym, on the running track, at a yoga studio, in the pool, or exploring a new
                sport, Fit-Mate24 helps you find like-minded people who share your interests and goals.
              </p>
              <p style={{ fontSize: 15, fontFamily: 'Californian FB, serif', letterSpacing: 0.9 }}>
                Unlike traditional matching apps, Fit-Mate24 doesn’t decide who you should connect with. You have
                the freedom to browse profiles, discover people in your fitness community, and choose your own
                training partners and connections.
              </p>
              <p style={{ fontSize: 15, fontFamily: 'Californian FB, serif', letterSpacing: 0.9 }}>
                Because fitness is better together.
              </p>
              <a href={navigateTo}>
                <button
                  style={{
                    background: '#000',
                    borderRadius: 25,
                    padding: 15,
                    fontSize: 14,
                    color: 'white',
                    cursor: 'pointer',
                    width: 200,
                    fontFamily: 'Californian FB, serif',
                    letterSpacing: 0.9,
                  }}>
                  Download
                </button>
              </a>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <img src="howedoit.png" alt="icon" width={'90%'} />
            <div
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 600, // Poppins semibold
                fontSize: 14,
                textAlign: 'center',
                color: '#000',
                marginBottom: 15,
                letterSpacing: 0.9,
                marginTop: 20,
              }}>
              How we do it
            </div>
            <div style={{ width: '70%', fontFamily: 'Californian FB, serif' }}>
              <p>Browse Profiles</p>
              <li style={{ opacity: 0.6, marginTop: -15 }}>
                see people near you who share your fitness goals, schedule, or training style. Fit-Mate24 does not use
                any matching algorithms…you decide who to connect with, giving you full control over finding your
                workout buddy.
              </li>

              <p>Filter & Connect</p>
              <li style={{ opacity: 0.6, marginTop: -15 }}>
                Choose partners based on sport, routine, language, or level. whether you’re a beginner or advanced.
              </li>

              <p>Safe Communication</p>
              <li style={{ opacity: 0.6, marginTop: -15 }}>
                Chat directly in the app to plan sessions, with reminders to always meet in public training facilities.
              </li>

              <p>Fitness Tales & Explore </p>
              <li style={{ opacity: 0.6, marginTop: -15 }}>
                Share your progress, get inspired by others, and connect through stories-not just profiles.
              </li>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <div
          style={{
            display: 'flex',
            gap: 7,
            background: '#f5f1e9',
            padding: '25px 0',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#faf4e4',
          }}>
          <img
            src={'g1.png'}
            alt={`gallery-${1}`}
            style={{
              width: 130,
              borderRadius: 12,
              boxShadow: '0 2px 10px #0002',
              background: '#fff',
              marginLeft: -10,
            }}
          />
          <img
            src={'g2.png'}
            alt={`gallery-${1}`}
            style={{
              width: 200,
              borderRadius: 12,
              boxShadow: '0 2px 10px #0002',
              background: '#fff',
            }}
          />
          <img
            src={'g3.png'}
            alt={`gallery-${1}`}
            style={{
              width: 130,
              borderRadius: 12,
              boxShadow: '0 2px 10px #0002',
              background: '#fff',
              marginRight: -10,
            }}
          />
        </div>

        {/* download app */}
        <div
          style={{
            justifyContent: 'center',
            display: 'flex',
            backgroundColor: '#faf4e4',
            padding: '25px 0px',
            color: '#fff !important',
          }}>
          <div
            style={{
              background: '#000',
              width: '80%',
              padding: '22px 0',
              textAlign: 'center',
              borderRadius: 13,
            }}>
            <div style={{ fontWeight: 700, marginBottom: 5, fontFamily: 'Californian FB, serif', color: '#fff' }}>
              Get Started With Fit-Mate24{' '}
            </div>
            <div style={{ marginBottom: 5, fontSize: 12, fontFamily: 'Californian FB, serif', color: '#fff' }}>
              Let’s connect and be fit together!
            </div>
            <div style={{ marginBottom: 12 }}>
              <a href="https://play.google.com/store/games?&utm_source=emea_Med&utm_medium=hasem&utm_content=Mar2425&utm_campaign=Evergreen&pcampaignid=MKT-EDR-emea-de-1710138-Med-hasem-py-Evergreen-Mar2425-Text_Search_BKWS-id_104073_%7CEXA%7CONSEM_kwid_34087548205&gad_source=1&gad_campaignid=18591438178&gclid=CjwKCAjw6P3GBhBVEiwAJPjmLtICI2bLcY1nT-KoabwUVfr_Xj7Zs6RIRMB9Y0Uy_dWz6QuYTfK19hoCkj8QAvD_BwE">
                <img
                  src="google.svg"
                  alt="Google Play"
                  style={{ width: 80, verticalAlign: 'middle', marginRight: 4 }}
                />
              </a>

              <a href="https://apps.apple.com/de/app/fit-mate24/id6584512797?l=en-GB">
                <img src="iosbuttondisplay.png" alt="Apple" style={{ width: 70, verticalAlign: 'middle' }} />
              </a>
            </div>
          </div>
        </div>

        {/* Footer & Social */}
        <div
          style={{
            background: '#18181a',
            color: '#fff',
            padding: '24px 18px 14px 18px',
            fontSize: 17,
            border: '1px solid #232223',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            fontFamily: 'Californian FB, serif',
          }}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}>
            {/* Left block */}
            <div>
              <div style={{ fontSize: 23, marginBottom: 35, marginTop: 5 }}>Fit-Mate24</div>
              <div style={{ fontSize: 16, marginBottom: 35 }}>
                Contact:{' '}
                <span style={{ color: '#C87E4C' }}>
                  <a
                    href="mailto:info@fit-mate24.com"
                    style={{ color: '#C87E4C', textDecoration: 'none' }}
                    className="email-link"
                    target="_blank"
                    rel="noopener noreferrer">
                    info@fit-mate24.com
                  </a>
                </span>
              </div>
              <div style={{ fontSize: 15, marginBottom: 12 }}>Follow us on:</div>
              <div style={{ display: 'flex', gap: 14 }}>
                <a href="https://x.com/fmate24?s=21" aria-label="Twitter" style={{ display: 'inline-block' }}>
                  <img src="twitter.svg" alt="" />
                </a>
                <a
                  href="https://www.instagram.com/fitmate24?igsh=YTJieDhsZ3VpYnU2"
                  aria-label="Instagram"
                  style={{ display: 'inline-block' }}>
                  <img src="insta.svg" alt="" />
                </a>
                <a
                  href="https://www.tiktok.com/@fitmate24?_t=ZN-90FFzIIKQqM&_r=1"
                  aria-label="Facebook"
                  style={{ display: 'inline-block' }}>
                  <img src="tiktok.png" alt="" height={20} />
                </a>
              </div>
            </div>
            {/* Right links */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                fontSize: 16,
                gap: 14,
                marginTop: 8,
              }}>
              <a href="/terms-and-conditions" style={{ color: '#C87E4C', textDecoration: 'none', marginBottom: 23 }}>
                Terms and Conditions
              </a>
              <a href="/privacy-policy" style={{ color: '#C87E4C', textDecoration: 'none', marginBottom: 20 }}>
                Privacy Policy
              </a>
              <a
                href="/delete-user-account-policy"
                style={{ color: '#C87E4C', textDecoration: 'none', marginBottom: 20 }}>
                Delete account Policy
              </a>
            </div>
          </div>
          <div style={{ width: '100%', textAlign: 'center', fontSize: 16, marginTop: 22 }}>
            <span style={{ fontSize: 21, verticalAlign: 'middle', marginRight: 7 }}>©</span>
            {new Date().getFullYear()} Fit-Mate24. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}
